<!-- Zweck: Stellt die HTML-Struktur für shop warenkorb entry edit fields component im Frontend bereit. -->
@if (editEntry) {
  <div class="shop-warenkorb-entry-editor">
    <permission-block [oneOfRoles]="['Vertreter']">
      @if ((
        (vertreterconfig|async)?.DomainVertreterShowPositionsart ||
        (vertreterconfig|async)?.DomainVertreterShowFreimenge ||
        (vertreterconfig|async)?.DomainVertreterShowAktionsrabattmenge ||
        (vertreterconfig|async)?.DomainVertreterShowAktionsrabattprozent ||
        (vertreterconfig|async)?.DomainVertreterShowBasisverrechnungspreis
        )
        && (disableDialog || !((vertreterconfig|async)?.DomainVertreterUseDialog))) {
        <div style="display: inline-block" class="tut_wkpos_vertr"
          >
          @if ((vertreterconfig|async)?.DomainVertreterShowPositionsart && (disableDialog || !((vertreterconfig|async)?.DomainVertreterUseDialog))) {
            <mat-form-field class="positionsartinput" appearance="outline"
              >
              <mat-label>PA</mat-label>
              <mat-select [(value)]="editEntry.positionsart" matTooltip="Positionsart" (change)="change()"
                [disabled]="disabled">
                <mat-option [value]="'Standard'">Standard</mat-option>
                <mat-option [value]="'OhneVerrechnung'">Ohne Verrechnung</mat-option>
                <mat-option [value]="'NurVerrechnung'">Nur Verrechnung</mat-option>
              </mat-select>
            </mat-form-field>
          }
          @if ((vertreterconfig|async)?.DomainVertreterShowFreimenge && (disableDialog || !((vertreterconfig|async)?.DomainVertreterUseDialog))) {
            <nice-number-input
              #inputFreimenge
              label="FM" tooltip="Freimenge (0-x) - Kann leer gelassen werden" [disabled]="disabled"
              [step]="1" [min]="0" [max]="null"
              class="freimengeinput" [(value)]="editEntry.freimenge"
              [nullable]="true"
            (change)="change()"></nice-number-input>
          }
          @if ((vertreterconfig|async)?.DomainVertreterShowAktionsrabattmenge && (disableDialog || !((vertreterconfig|async)?.DomainVertreterUseDialog))) {
            <nice-number-input
              #inputAktionsrabattmenge
              label="AM" tooltip="Aktionsrabatt Menge (0-x) - Kann leer gelassen werden" [disabled]="disabled"
              [step]="1" [min]="0" [max]="null"
              class="aktionsrabattprozentinput" [(value)]="editEntry.aktionsrabattmenge"
              [nullable]="true"
            (change)="change()"></nice-number-input>
          }
          @if ((vertreterconfig|async)?.DomainVertreterShowNaturalrabattmenge && (disableDialog || !((vertreterconfig|async)?.DomainVertreterUseDialog))) {
            <nice-number-input
              #inputNaturalrabattmenge
              label="NM" tooltip="Naturalrabatt Menge (0-x) - Kann leer gelassen werden" [disabled]="disabled"
              [step]="1" [min]="0" [max]="null"
              class="naturalsrabattmengeinput" [(value)]="editEntry.naturalrabattmenge"
              [nullable]="true"
            (change)="change()"></nice-number-input>
          }
          @if ((vertreterconfig|async)?.DomainVertreterShowAktionsrabattprozent && (disableDialog || !((vertreterconfig|async)?.DomainVertreterUseDialog))) {
            <nice-number-input
              #inputAktionsrabattprozent
              label="AP" tooltip="Aktionsrabatt Prozent (0-100) - Kann leer gelassen werden" [disabled]="disabled"
              [step]="1" [min]="0" [max]="100"
              class="aktionsrabattprozentinput" [(value)]="editEntry.aktionsrabattprozent"
              [nullable]="true"
            (change)="change()"></nice-number-input>
          }
          @if ((vertreterconfig|async)?.DomainVertreterShowBasisverrechnungspreisRabattProzent && (disableDialog || !((vertreterconfig|async)?.DomainVertreterUseDialog))) {
            <nice-number-input
              #inputBasisverrechnungspreisprozent
              label="Rabatt" tooltip="Rabatt Prozent (0-100)" [disabled]="disabled"
              [step]="1" [min]="0" [max]="100"
              class="basisverrechnungspreisprozentinput" [(value)]="editEntry.basisverrechnungspreisrabattprozent"
            (change)="change()"></nice-number-input>
          }
          @if ((vertreterconfig|async)?.DomainVertreterShowBasisverrechnungspreis && (disableDialog || !((vertreterconfig|async)?.DomainVertreterUseDialog))) {
            <nice-number-input
              #inputBasisverrechnungspreis
              label="BVP" tooltip="Basisverrechnungspreis (0-x)" [disabled]="disabled"
              [step]="0.01" [min]="0" [max]="null"
              class="basisverrechnungspreisinput" [(value)]="editEntry.basisverrechnungspreis"
            (change)="change()"></nice-number-input>
          }
        </div>
      }
    </permission-block>
    <nice-number-input label="Menge" tooltip="Menge (0-x)"
      #inputMenge
      [step]="1" [min]="0" [max]="null" [disabled]="disabled"
      class="mengeinput tut_wkpos_amount" [(value)]="editEntry.menge"
    (change)="change()" (mengeKeydownEnter)="mengeEnter()"></nice-number-input>
    <ng-content></ng-content>
  </div>
}
